module.exports = __webpack_public_path__ + "static/media/cover-trucastuce-ha.ecff9c89.jpeg";